module.exports = __webpack_public_path__ + "static/media/logo.52c9a2d0.png";